<small class="pm-form-field-error Error">
  @if (errorMessage()) {
    <span *ngIf="ctrl.invalid && ctrl.dirty" class="pm-form-error-message-container">
      <span class="material-symbols-outlined">warning</span>
      &nbsp;
      <span>
        {{ errorMessage() }}
      </span>
    </span>
  }
</small>
